<!-- 流量详情 -->
<template>
  <div class="detail">
    <div class="detail-header">
      <app-header @on-click="e_goBack"
        backgroundColor="#F2F2F2"
        :title="$t('flowDetail.title')"></app-header>
    </div>
    <div class="detail-data">
      <div class="detail-con">
        <div class="detail-con-flow">
          <div class="flowCon">
            <ul class="flowItem">
              <li class="flow-title">{{data.goodsName}}</li>
              <li v-if="data.a_maxCount > 1"
                class="maxCount">×{{data.a_maxCount}}</li>
              <li v-if="isValid && (!data.extendValVos || !data.a_getValue_hideFlowSize || data.a_getValue_hideFlowSize && data.a_getValue_hideFlowSize != '1')"
                class="progress-wrap">
                <p v-if="progress > 0.33"
                  class="progress"
                  :style="{width: `${progress * 100}%`}">
                  <span class="ml8 no-wrap">{{$t("flowDetail.dataLeft")}} : {{data.a_surplusFlow.remainFlow | filterFlow}}</span>
                </p>
                <div class="flex" v-else>
                  <p class="progress fl"
                    :style="{width:`${progress * 100}%`}">
                  </p>
                  <span class="ml8 lessQuarter">{{$t("flowDetail.dataLeft")}} : {{data.a_surplusFlow.remainFlow | filterFlow}}</span>
                </div>
              </li>
              <li class="mt8 clearfix"
               v-if="!data.extendValVos || !data.a_getValue_hideFlowSize || data.a_getValue_hideFlowSize && data.a_getValue_hideFlowSize == '0' ">{{$t('flowDetail.flow')}}
                <span class="fr flow-nameDesc left-nameDesc">{{data.a_surplusFlow.flow | filterFlow}} {{$t("packages.high_speed_text")}}{{flowCycle}}</span>
              </li>
              <li v-if="!isValid"
                class="mt8">{{$t('flowDetail.validity')}}
                <span class="fr left-nameDesc">{{data.period}}{{$t(`packages.periodUnitsSimp.${data.periodUnit.toLowerCase()}`)}}</span>
              </li>
              <li v-if="isValid"
                class="mt8">{{$t('flowDetail.validTime')}}
                <span class="fr left-nameDesc">{{data.effectiveTime | filterTime}}</span>
              </li>
              <li v-if="isValid"
                class="mt8">{{$t('flowDetail.invalidTime')}}
                <span class="fr left-nameDesc">{{data.expiryTime | filterTime}}</span>
              </li>
            </ul>
          </div>
          <div class="flowCon mt8">
            <ul class="flowItem">
              <li class="title"
                @click="showRegion = !showRegion">{{$t('flowDetail.coverage')}}
                <van-icon class="fr toggle-btn"
                  :name="showRegion ? 'arrow-up' : 'arrow-down'" />
              </li>
              <li :class="{'van-multi-ellipsis--l3': !showRegion}"
                class="region">{{data.mccList.toString()}}</li>
            </ul>
          </div>
          <div class="flowCon mt8">
            <ul class="flowItem">
              <li class="title">{{$t('flowDetail.useIntro')}}</li>
              <li v-html="data.attrMap.pkDesc"></li>
            </ul>
          </div>
          <div class="flowCon mt8">
            <ul class="flowItem">
              <li class="mt8">{{$t('flowDetail.purchaseTime')}}
                <span class="fr">{{data.createTime | filterTime}}</span>
              </li>
              <li class="mt8">{{$t('flowDetail.subtotal')}}
                <span class="fr">{{globalPriceFormat(currencyUnit, data.price)}} </span>
              </li>
              <!-- <li class="van-hairline--top status">{{$t('flowDetail.status')}}
                <span class="fr">{{$t(`invalidFlow.state.${data.status}`)}}</span>
              </li> -->
            </ul>
          </div>
        </div>
      </div>
      <div class="detail-toBuy"
        v-show="orderCancelFlag || isBuyFlag || unsubscribeFlag">
        <button @click="e_cancelOrder(data)"
          class="unsubscribe btn"
          v-show="orderCancelFlag">{{$t('flowDetail.cancel')}}</button>
        <button class="buy-again btn ml10"
          @click="e_buyAgain(data)"
          v-show="isBuyFlag && !unsubscribeFlag">{{$t('flowDetail.buyAgain')}}</button>

          <!-- 不考虑三个并行，
          * 连续包月不能再次购买
          * 也不是普通取消订单
          -->
          <button class="buy-again btn ml10 subscribeBtn"
          @click="dialogShowUnsubscribe = true"
          v-show="unsubscribeFlag"
          >{{$t('flowDetail_unsubscribe')}}</button>
      </div>
    </div>
    <div class="recharge_dialog">
        <van-popup v-model:show="dialogShowUnsubscribe" 
                  position="bottom" :style="{ 'max-height': '80%' }" 
                  round closeable 
                  :overlay-style="{background:'rgba(0, 0, 0, 0.5)'}"
                  :close-on-click-overlay="false">
            <div>
                <!--退订-->
                
                <div class="recharge_num">
                    <p v-text="$t('flowDetail_unsubscribe')" style="text-align:center; display: block;"></p>
                    <div class="otherOp" v-text="$t('flowDetail_confirmAgreementUnsubscribe')"></div>
                </div>
                <div class="pay_btn two_btn">
                    <button @click="dialogShowUnsubscribe = false" type="primary" class="primary_after">{{$t('flowDetail_cancel')}}</button>
                    <button @click="e_unsubscribeAgreement" type="primary" >{{$t('flowDetail_unsubscribe')}}</button>
                </div>
            </div>

        </van-popup>
    </div>
    <div class="recharge_dialog">
        <van-popup v-model:show="unsubscribeAgreementSuccessFlag" 
                    position="bottom" :style="{ 'max-height': '80%' }" 
                    round closeable 
                    :overlay-style="{background:'rgba(0, 0, 0, 0.5)'}"
                    :close-on-click-overlay="false">
            <div class="do_success">
                <!--取消成功-->
                <img @click.prevent="" :src="$NeWDomain.getImgUrl('imgs/success-icon.png')">

                <p>{{$t('flowDetail_cancelSuccess')}}</p>
            </div>

        </van-popup>
    </div>

  </div>
</template>

<script>
import { popup } from 'vant';
import { Dialog } from "vant";
import cookie from "../../utils/cookie";
import dateUtil from "../../utils/DateUtil";
import { keepTwodecimalFixed } from "../../utils/util";
export default {
  name: "OrderDetail",
  data() {
    return {
      data: {
        goodsName: "",
        period: 1,
        periodUnit: "DAY",
        remainFlow: 0,
        flow: 0,
        effectiveTime: 0,
        expiryTime: 0,
        mccList: [],
        createTime: 0,
        price: 0,
        status: "",
        attrMap: {},
        a_surplusFlow: {},
        accumulatedFlowList: [],
      },
      showRegion: false,
      currencyUnit: "",
      orderCancelFlag: false,
      isBuyFlag: false,
      // dialogShow:false,
      dialogShowUnsubscribe:false,
      subscribeFlag:false,//是否已经退订
      unsubscribeFlag:false,//是否取消连续包月
      unsubscribeAgreementSuccessFlag:false//取消连续包月成功
    };
  },
  computed: {
    progress() {
      return this.data.a_surplusFlow.remainFlow / this.data.a_surplusFlow.flow;
    },
    isValid() {
      return !!this.data.effectiveTime;
    },
    flowTypeTitle() {
      if (this.data.goodsType == "DISC" && ["BYTC", "SWBY", "BTTC", "LXCX"].includes(this.data.categoryCode)) return this.$t("packages.high_speed_text");
      return "";
    },
    flowCycle() {
      let da = this.data.accumulatedFlowList && this.data.accumulatedFlowList[0];
      if (!da) return "";
      let cycleUnit = { "0": "hour", "1": "day", "2": "month", "3": "year" , "12": "month" }[da.cycle];
      return da.cycleValue > 1 ? "/"+ da.cycleValue + this.$t(`packages.periodUnitsSimp.${cycleUnit}`) : "" ;
    }
  },
  methods: {
    async init() {
      await this.getCurrencyUnit();
      
      this.data = JSON.parse(sessionStorage.getItem("flowDetailData"));

      if (this.data.payAgreeFlag == '1') {
        this.queryAgreement(this.data);
      }
      this.checkCancel();
    },
    queryAgreement(){
        let that = this;
        let sessionStorage_UrlData = JSON.parse(sessionStorage.getItem('urlData') || '{}');
        let data = {
          imei:sessionStorage_UrlData.imei,
        }
        //查询连续包月的协议
        this.$http.post(this.$api.queryAgreement,data).then((res)=>{
              var agreementMapKeys = Object.keys(res.data.agreementMap);
              var agreementsLength = agreementMapKeys.length;
              if (agreementsLength > 0) {
                  for (var i = 0; i < agreementsLength; i++) {
                      if (res.data.agreementMap[agreementMapKeys[i]].indexOf(that.data.relationId) != -1) {
                          that.unsubscribeFlag = true;
                          that.data.payAgreeId = agreementMapKeys[i];
                          break;
                      }
                  }
              }
        },res=>{
            this.$toast(res.resultDesc);
        });
    },
    //获取货币单位
    getCurrencyUnit() {
      let _currencyUnit = sessionStorage.getItem("currencyUnit");
      if (_currencyUnit) return (this.currencyUnit = _currencyUnit);
      this.$http
        .post({
          url: "/bss/app/user/QueryUserInfo",
          data: {
            queryAmount: 1
          }
        })
        .then(da => {
          this.currencyUnit = da.data.currencyType || "";
          if (this.currencyUnit) sessionStorage.setItem("currencyUnit", this.currencyUnit);
        });
    },
    //检查是否可退订
    checkCancel() {
      if (!this.data.orderId) return;
      this.$http
        .post({
          url: "/bss/app/orderRelation/checkOrderCanCancelOrReBuy",
          data: {
            orderId: this.data.orderId,
            channel: "WEB"
          }
        })
        .then(da => {
          this.orderCancelFlag = da.data.orderCancelFlag;
          this.isBuyFlag = da.data.isBuyFlag;
        });
    },
    e_goBack() {
      sessionStorage.removeItem('orderType');
      this.$router.go(-1);
    },
    e_buyAgain({ goodsCode, categoryCode, goodsType }) {
      this.$router.push(this.$setRouteQuery({
        name: "PackageDetail",
        query: {
          goodsCode,
          categoryCode,
          goodsType,
          souce:'我的流量-再次购买'
        }
      },this));
    },
    e_cancelOrder({ orderId }) {
      Dialog.confirm({
        title: this.$t("flowDetail.tip"),
        message: this.$t("flowDetail.cancelTip")
      }).then(() => {
        this.$http
          .post({
            url: "/bss/app/order/CancelOrder",
            data: {
              orderId
            }
          })
          .then(da => {
            sessionStorage.removeItem('orderType');
            this.$router.push(this.$setRouteQuery({name: 'OrderList',query:{back:'Home'}},this));
          });

          // 神策-点击取消订单
          this.$sensors.track('WebUnsubscribeClick', {
            order_id:this.data.orderId,
            data_package_code:this.data.goodsCode,
            data_package_name:this.data.goodsName, 
            // data_package_quantity:this.data.a_maxCount,
            // order_effective_time: dateUtil.formatDateTime(new Date(this.data.effectiveTime), 'yyyy-MM-dd HH:mm'),
            // order_expiry_time:dateUtil.formatDateTime(new Date(this.data.expiryTime), 'yyyy-MM-dd HH:mm'),
            order_buy_time:dateUtil.formatDateTime(new Date(this.data.createTime), 'yyyy-MM-dd HH:mm'),
            monetary_unit:this.currencyUnit,
            order_payment_amount:+this.data.price / 100,
          });
      });
    },
    e_unsubscribeAgreement(){
        let that = this;
        let data = {
            payAgreeId: that.data.payAgreeId
        };
        this.$http.post(this.$api.account_unbindAgreement,data).then((res)=>{
            that.unsubscribeFlag = false;
            that.dialogShowUnsubscribe = false;
            that.unsubscribeAgreementSuccessFlag = true;
            setTimeout(() => {
                that.unsubscribeAgreementSuccessFlag = false;
                console.log(that.isBuyFlag);
            },3000);
        },res=>{
            this.$toast(res.resultDesc);
        });
    }
  },
  filters: {
    filterFlow(da) {
      if (da == 0) return "0MB";
      if (!da) return "";
      let flow = keepTwodecimalFixed(da < 1000 ? da : da / 1024);
      let langType = cookie.getCookie('langType')
      // 部分欧洲国家小数点采取 ， 形式
      let country = ['es-ES','pt-PT','de-DE','fr-FR']; 
      let showFlow = flow.toString().replace(/\.00$|0$/, "")
      if(country.includes(langType)){
          showFlow = showFlow.replace('.',',')
      }
      return `${showFlow}${(da < 1000 && "MB") || "GB"}`;
    },
    filterTime(time) {
      if (!time) return "";
      let dateFormat = 'yyyy-MM-dd HH:mm'
      let langType = cookie.getCookie('langType')
      if(['es-ES','pt-PT','de-DE','fr-FR','it-IT','tr-TR'].includes(langType)){
        dateFormat = 'dd/MM/yyyy HH:mm'
      }
      return dateUtil.formatDateTime(new Date(time), dateFormat);
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style lang="less" scoped>
@import "css/detail.less";
.recharge_dialog .vux-no-group-title{margin-top: 0;border:none;}
.recharge_dialog .vux-no-group-title .weui-cell:before{border-top:none;}
/*底部弹框*/
.recharge_dialog .vux-van-popup-dialog{background:#fff;border-top-left-radius: .192rem;border-top-right-radius: .192rem;}
.recharge_dialog .recharge_num{overflow: hidden;margin: 0 .6rem;padding: .8rem 0; }
.recharge_dialog .recharge_num p{display: inline-block;font-size: .46rem;color: #333333;letter-spacing: 0;line-height: .3072rem;font-weight: bold;}
.recharge_dialog .recharge_num span{display: inline-block;font-size: .3rem;color: #F74E4E;letter-spacing: 0;text-align: right;line-height: .3072rem;font-weight: bold;}
.pay_tip{line-height: .576rem; background: #FBF8E8;border: 0 solid #FFE7C6;font-size: .42em;color: #FFB242;letter-spacing: 0;text-align: center;}
.pay_tips{font-size: .2304rem;}
.pay_btn button,.two_btn button{border-radius: 0;background-image: linear-gradient(-134deg, #A1E070 0%, #68BE3D 100%);font-size: .42rem;color: #FFFFFF;letter-spacing: 0;text-align: center;line-height: 1.45rem;outline: none;}
.pay_btn button:after{border: none;}
.recharge_dialog .otherOp{clear: both;font-size: .38rem;color:#666;padding-top: .62rem;}
.two_btn button{background: #f7f7f7;color:#666;width: 49.8%;display: inline-block;padding: 0;float: left;margin: 0;position: relative;}
.two_btn button:nth-child(2){color:#F74E4E;}
.do_success{text-align: center;padding: .768rem 0;}
.do_success img{width: 1rem;}
.do_success p{font-size: .46rem;margin: .4608rem 0 .3072rem 0;font-weight: bold;}
.do_success span{font-size: .2688rem;color: #666666;}
.cell-x-icon {display: block;fill: #68BE3D;}
.fz16px{font-size: .42rem;}
.primary_after:after{content: "|";position:absolute;right: 0;top: 50%;transform: translateY(-50%);color: #dbdbdb;}
.detail .detail-data .buy-again.subscribeBtn{background: #FF4E4E;}
html[dir="rtl"] {
  .two_btn button{float: right;}
  .primary_after:after {right:unset;left:0}
  .detail ::v-deep .van-popup .van-icon {right:unset;left:0.444444rem}
}
</style>